const createFormData = (formData, files) => {
  const bodyFormData = new FormData();
  Object.keys(formData ?? {}).forEach((k) => {
    const v = formData[k];
    if (v === undefined || v === null) {
      return;
    }
    bodyFormData.append(k, JSON.stringify(v));
  });

  if (files && files.length) {
    files.forEach((file) => {
      bodyFormData.append("files[]", file, `${file.name}`);
    });
  }
  return bodyFormData;
};

export default createFormData;
